import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-semibold text-background-50 tracking-tight">
                Sugargoo<span className="text-primary-400">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-background-300 max-w-md leading-relaxed">
              Your ultimate independent resource for Sugargoo Spreadsheet discoveries, shopping guides, reviews, and expert tips. We help shoppers find the best products and navigate the Sugargoo platform with confidence.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-spreadsheet-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-review" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/article/is-sugargoo-legit" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Is Sugargoo Legit?
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors"
                >
                  Sugargoo Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Guides &amp; Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/sugargoo-shipping-cost" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-coupon" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Coupons &amp; Discounts
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-saving-tips" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Money Saving Tips
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-warehouse" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  Warehouse Guide
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-qc-photos" className="text-sm text-background-300 hover:text-primary-400 transition-colors">
                  QC Photos Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} SugargooSheet. All rights reserved. This is an independent resource and is not affiliated with Sugargoo.
          </p>
          <p className="text-xs text-background-400">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-primary-400 transition-colors"
            >
              Visit Main Website &rarr;
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}